import { gql } from 'apollo-angular';

const GET_POTENTIAL_SELLERS = gql`
  query GetPotentialSellers($rfpId: Long) {
    potentialSellers(rfpId: $rfpId) {
      id
      name
      address {          
			  address1   
			  city       
			  state      
		  }
      diversityInformation
      selected
      primaryCategoryCount
      leafCategoryCount
      spend {
        actualSpend
        annualizedSpend
        continuedSpend
        potentialSpend
        marketShare
      }
      categories {
        id
        name
        hierarchy
        parentId
        leafCategoryCount
        carvedInProductCount
        spend {
          actualSpend
          annualizedSpend
          continuedSpend
        }
        sellerSpend {
          actualSpend
          annualizedSpend
          continuedSpend
          potentialSpend
          marketShare
        }
        categoryAddendum {
          id
          url
        }
      }
    }
  }
`;

export default GET_POTENTIAL_SELLERS;
